// eslint-disable-next-line import/prefer-default-export
export const BulkUploadStyle = {
    root: {
        '& .sct-icon': {
            fontSize: '18px',
            cursor: 'pointer',
        },
    },
    form: {
        width: '250px',
        margin: '10px 0',
        display: 'block',
        '& .MuiOutlinedInput-root': {
            width: '100%',
        },
    },
    checkBox: {
        marginLeft: '6px',
        display: 'block',
        height: '25px',
        '& .MuiFormControlLabel-label': {
            fontSize: '12px',
            lineHeight: '16px',
            color: 'rgba(0,0,0,0.87)',
        },
    },
};
